import React, { useState, useEffect } from 'react';

// Helper function to properly encode image paths with spaces and special characters
const encodeImagePath = (path) => {
  return path.split('/').map(segment => 
    encodeURIComponent(segment)
  ).join('/');
};

function ProjectsPageNew({ onProjectClick }) {
  const [activeFilter, setActiveFilter] = useState('all');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const projects = [
    // Construction Projects
    {
      id: 0,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/Khajekhalan%20Ghat%20Patna/1.png",
      location: "Patna, Bihar",
      title: "Khajekhalan Ghat Patna",
      description: "Riverfront development project enhancing infrastructure and amenities at Patna ghat."
    },
    {
      id: 1,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/Khajuraho%20Landscape%20Development/1.png",
      location: "Khajuraho, Madhya Pradesh",
      title: "Khajuraho Landscape Development",
      description: "Landscape development project enhancing the aesthetic appeal of the historic Khajuraho region."
    },
    {
      id: 2,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/LIC%20Apartments%2C%20Canal%20Street%2C%20Kolkata/1.png",
      location: "Canal Street, Kolkata",
      title: "LIC Apartments, Canal Street",
      description: "Modern residential complex with sustainable design and contemporary amenities."
    },
    {
      id: 3,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/LIC%20Bhagalpur%2C%20Bihar/1.png",
      location: "Bhagalpur, Bihar",
      title: "LIC Bhagalpur",
      description: "Commercial office development for LIC operations in Bhagalpur."
    },
    {
      id: 4,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/LIC%20DO%2C%20Udaipur/1.png",
      location: "Udaipur, Rajasthan",
      title: "LIC Divisional Office, Udaipur",
      description: "Modern office complex with traditional Rajasthani architectural influences."
    },
    {
      id: 5,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/LIC%20Mixed%20Use%20Development%2C%20Vadodara%2C%20Gujarat/1.png",
      location: "Vadodara, Gujarat",
      title: "LIC Mixed Use Development, Vadodara",
      description: "Integrated mixed-use development combining commercial and residential spaces."
    },
    {
      id: 6,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/LIC%20Policy%20Holders%20Housing%2C%20Kolkata/1.png",
      location: "Kolkata, West Bengal",
      title: "LIC Policy Holders Housing",
      description: "Residential housing project designed for LIC policy holders with modern amenities."
    },
    {
      id: 7,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/LIC%20ZTC%2C%20Jamshedpur%2C%20Jharkhand/1.png",
      location: "Jamshedpur, Jharkhand",
      title: "LIC ZTC Jamshedpur",
      description: "Zonal Training Centre with modern training facilities and infrastructure."
    },
    {
      id: 8,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/LIC%2C%20Satara%2C%20Maharashtra/1.png",
      location: "Satara, Maharashtra",
      title: "LIC Office, Satara",
      description: "Regional office development with contemporary design and efficient space planning."
    },
    {
      id: 9,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/National%20Institute%20of%20Oceanography%2C%20Goa/1.png",
      location: "Goa",
      title: "National Institute of Oceanography",
      description: "State-of-the-art research facility designed for marine science and oceanographic studies."
    },
    {
      id: 10,
      category: "construction",
      image: "/assets/RIPL%20Projects/Construction/Tourist%20Infrastructure%20Facilities%2C%20Kanheri%20Caves%2C%20Mumbai/1.png",
      location: "Mumbai, Maharashtra",
      title: "Tourist Infrastructure, Kanheri Caves",
      description: "Heritage-sensitive infrastructure development enhancing visitor experience at Kanheri Caves."
    },
    // Interiors Projects
    {
      id: 11,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/14%20Floor%2C%20State%20Bank%20Bhavan%2C%20Mumbai/1.png",
      location: "Mumbai, Maharashtra",
      title: "14th Floor, State Bank Bhavan",
      description: "Executive floor interiors with premium finishes and modern workspace design."
    },
    {
      id: 12,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/Income%20Tax%20Office%2C%20Swargate%2C%20Pune/1.png",
      location: "Swargate, Pune",
      title: "Income Tax Office",
      description: "Government office interiors designed for efficiency and public accessibility."
    },
    {
      id: 13,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/NABARD%2C%20Pune/1.png",
      location: "Pune, Maharashtra",
      title: "NABARD Office Interiors",
      description: "Professional workspace with modern amenities and efficient layout planning."
    },
    {
      id: 14,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20Audiotorium%2C%20Mumbai/1.png",
      location: "Mumbai, Maharashtra",
      title: "SBI Auditorium",
      description: "Multi-purpose auditorium with advanced acoustics and state-of-the-art facilities."
    },
    {
      id: 15,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20Conference%20Center%2C%20State%20Bank%20Bhavan%2C%20Mumbai/1.png",
      location: "Mumbai, Maharashtra",
      title: "SBI Conference Center",
      description: "State-of-the-art conference facilities with advanced AV systems and elegant finishes."
    },
    {
      id: 16,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20General%20Insurance%2C%20Thane/1.png",
      location: "Thane, Maharashtra",
      title: "SBI General Insurance",
      description: "Corporate office interiors with modern design and ergonomic workspace planning."
    },
    {
      id: 17,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20LHO%20BKC%2C%20Mumbai/1.png",
      location: "BKC, Mumbai",
      title: "SBI Local Head Office",
      description: "Contemporary office interiors designed for enhanced productivity and employee comfort."
    },
    {
      id: 18,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20Life%20Insurance%2C%20Andheri/1.png",
      location: "Andheri, Mumbai",
      title: "SBI Life Insurance, Andheri",
      description: "Modern office interiors with customer-centric design and efficient workflow."
    },
    {
      id: 19,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20Life%20Insurance%2C%20Guwahati/1.png",
      location: "Guwahati, Assam",
      title: "SBI Life Insurance, Guwahati",
      description: "Regional office interiors with contemporary design and local cultural elements."
    },
    {
      id: 20,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20Mutual%20Fund%20BKC%2C%20Mumbai/1.png",
      location: "BKC, Mumbai",
      title: "SBI Mutual Fund",
      description: "Premium financial services office with sophisticated design and client meeting areas."
    },
    {
      id: 21,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20Reception%20Lobby%2C%20State%20Bank%20Bhavan%2C%20Mumbai/1.png",
      location: "Mumbai, Maharashtra",
      title: "SBI Reception Lobby",
      description: "Impressive reception area reflecting the corporate identity with modern design elements."
    },
    {
      id: 22,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/SBI%20Wealth%20Management%2C%20Air%20India%20Building%2C%20Mumbai/1.png",
      location: "Mumbai, Maharashtra",
      title: "SBI Wealth Management",
      description: "Premium interior spaces designed for wealth management services with sophisticated finishes."
    },
    {
      id: 23,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/Sports%20Facilities%2C%20Mazagaon%20Docks%20Limited%2C%20Mumbai/1.png",
      location: "Mazagaon, Mumbai",
      title: "Sports Facilities, MDL",
      description: "Employee sports and recreation facilities with modern amenities and design."
    },
    {
      id: 24,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/UTIITSL%2C%20Thane/1.png",
      location: "Thane, Maharashtra",
      title: "UTIITSL Office",
      description: "Technology service office with contemporary design and collaborative workspaces."
    },
    {
      id: 25,
      category: "interiors",
      image: "/assets/RIPL%20Projects/Interiors/Visitor%20Facility%20Center%2C%20Khajuraho%20Group%20of%20Monuments/1.png",
      location: "Khajuraho, Madhya Pradesh",
      title: "Visitor Facility Center",
      description: "Culturally sensitive interior design for heritage site visitor facilities."
    },
    // Retrofitting Projects
    {
      id: 26,
      category: "retrofitting",
      image: "/assets/RIPL%20Projects/Retrofitting/Bank%20of%20Maharashtra%2C%20Shivaji%20Nagar%2C%20Pune/1.png",
      location: "Shivaji Nagar, Pune",
      title: "Bank of Maharashtra",
      description: "Seismic retrofitting and modernization of heritage banking facility."
    },
    {
      id: 27,
      category: "retrofitting",
      image: "/assets/RIPL%20Projects/Retrofitting/IGIDR%2C%20Goregaon%2C%20Mumbai/1.png",
      location: "Goregaon, Mumbai",
      title: "IGIDR Campus",
      description: "Structural rehabilitation and modernization of educational research institute."
    },
    {
      id: 28,
      category: "retrofitting",
      image: "/assets/RIPL%20Projects/Retrofitting/IOCL%20Goa/Gemini_Generated_Image_1rk3w91rk3w91rk3.png",
      location: "Goa",
      title: "IOCL Facility",
      description: "Industrial facility retrofitting ensuring compliance with modern safety standards."
    },
    {
      id: 29,
      category: "retrofitting",
      image: "/assets/RIPL%20Projects/Retrofitting/Radhika%20Apartments%2C%20Prabhadevi%2C%20Mumbai/1.png",
      location: "Prabhadevi, Mumbai",
      title: "Radhika Apartments",
      description: "Residential building retrofitting with enhanced structural safety features."
    },
    {
      id: 30,
      category: "retrofitting",
      image: "/assets/RIPL%20Projects/Retrofitting/State%20Bank%20Bhavan%2C%20Nariman%20Point%2C%20Mumbai/1.jpg",
      location: "Nariman Point, Mumbai",
      title: "State Bank Bhavan",
      description: "Comprehensive retrofitting of iconic landmark building with modern safety standards."
    },
    {
      id: 31,
      category: "retrofitting",
      image: "/assets/RIPL%20Projects/Retrofitting/Uddyan%20Building%2C%20Napeansea%20Road%2C%20Mumbai/1.png",
      location: "Napeansea Road, Mumbai",
      title: "Uddyan Building",
      description: "Heritage building restoration with modern engineering solutions."
    }
  ];

  const filterProjects = (category) => {
    setActiveFilter(category);
  };

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(p => p.category === activeFilter);

  return (
    <div id="projects-archive-view" className="view-section min-h-screen py-32 px-10 md:px-20 bg-black transition-all duration-500">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <h2 className="bank-gothic text-xs tracking-[0.5em] text-neutral-500 mb-4 uppercase">Selected Works</h2>
          <h3 className="bank-gothic text-4xl md:text-5xl">
            Architectural <span className="accent-text">Index</span>
          </h3>
        </div>

        {/* Projects Category Filter */}
        <div className="flex flex-wrap gap-6 mb-16 border-b border-white/5 pb-6 text-xs bank-gothic">
          <button 
            className={`portfolio-filter-btn pb-2 ${activeFilter === 'all' ? 'active text-white' : 'text-neutral-500 hover:text-white'}`}
            onClick={() => filterProjects('all')}
          >
            All Projects
          </button>
          <button 
            className={`portfolio-filter-btn pb-2 ${activeFilter === 'construction' ? 'active text-white' : 'text-neutral-500 hover:text-white'}`}
            onClick={() => filterProjects('construction')}
          >
            Construction
          </button>
          <button 
            className={`portfolio-filter-btn pb-2 ${activeFilter === 'interiors' ? 'active text-white' : 'text-neutral-500 hover:text-white'}`}
            onClick={() => filterProjects('interiors')}
          >
            Interiors
          </button>
          <button 
            className={`portfolio-filter-btn pb-2 ${activeFilter === 'retrofitting' ? 'active text-white' : 'text-neutral-500 hover:text-white'}`}
            onClick={() => filterProjects('retrofitting')}
          >
            Retrofitting
          </button>
        </div>

        {/* Complete Projects Index Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div 
              key={project.id}
              className="archive-project-card p-6 cursor-pointer group flex flex-col justify-between"
              onClick={() => onProjectClick(project.id)}
            >
              <div>
                <div className="aspect-[4/3] overflow-hidden mb-6 border border-white/5 relative">
                  <img 
                    src={project.image} 
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" 
                    alt={project.title}
                  />
                  <span className="absolute top-4 left-4 bg-black/80 px-3 py-1 text-[8px] bank-gothic tracking-widest accent-text">
                    {project.category.charAt(0).toUpperCase() + project.category.slice(1)}
                  </span>
                </div>
                <span className="bank-gothic text-[9px] text-neutral-500 tracking-widest">{project.location}</span>
                <h4 className="bank-gothic text-lg mt-3 mb-4 leading-snug group-hover:text-[#c49b66] transition-colors">
                  {project.title}
                </h4>
                <p className="text-xs text-neutral-400 font-light leading-relaxed mb-6">
                  {project.description}
                </p>
              </div>
              <div className="flex items-center space-x-2 text-xs bank-gothic text-[#c49b66]">
                <span>View Case Study</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProjectsPageNew;
